export default __webpack_public_path__ + "static/media/previous.85994716.svg";